import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { SUPPORTED_LANGUAGES } from '@/config/app.config';

Vue.use(VueI18n);

function loadLocaleInfo() {
  const locales = require.context('../locale', false, /[A-Za-z0-9-_,\s]+\.json$/i);
  const localeMessages: VueI18n.LocaleMessages = {};

  locales.keys().forEach((key) => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i);
      if (matched && matched.length > 1) {
        const locale = matched[1];

        // ignore locale files not yet in the supported language list.
        if (SUPPORTED_LANGUAGES.includes(locale)) {
          localeMessages[locale] = locales(key);
        }
      }
  });

  return { id: locales.id, localeMessages };
}

const localeInfo = loadLocaleInfo();

const options: VueI18n.I18nOptions = {
  messages: localeInfo.localeMessages, // set locale messages
  silentTranslationWarn: true, // hide console warnings of failed localization
};

const i18n = new VueI18n(options);

if (module.hot) {
  module.hot.accept(localeInfo.id, () => {
    const messages = loadLocaleInfo();
    Object.keys(messages).forEach((locale) => {
      i18n.setLocaleMessage(locale, messages.localeMessages[locale]);
    });
  });
}

const loadedLanguages = [''];

export async function loadLanguageAsync(lang: string, suName: string) {
  // If the language hasn't been loaded yet
  const messages = await import(`@/locale/su/${suName}/${lang}.json`);

  i18n.mergeLocaleMessage(lang, messages.default);
  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return;
  }
  loadedLanguages.push(lang);
  return;
}


export default i18n;
